import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Dictionaries and Code Quality`}</h1>
    <p>{`In this topic, you’ll expand your Python toolkit with one more data type: Dictionaries.`}</p>
    <p>{`When you want to associate different values of data with each other, like soccer players with their
scores or game players with their chosen usernames, you can use a Python dictionary. Jump into this
topic to learn how!`}</p>
    <Video alt="Dictionaries and Code Quality" videoId="oxzLGeMchSA" mdxType="Video" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      